import { configureStore } from "@reduxjs/toolkit";
import filterSlice from "../features/filters/filterSlice";
import scenarioLibrarySlice from "../features/scenarioLibrary/scenarioLibrarySlice";
import audioSlice from "../features/SpeechRecognition/audioSlice";
import authSlice from "../features/auth/authSlice";
import packSegmentsSlice from "../features/packSegments/packSegmentsSlice";
import formSlice from "../components/FormComponent/formSlice";
import metricsSlice from "../features/filters/metricsSlice";
import inputKpiSlice from "../features/inputKpi/inputKpiSlice";
import brandSlice from "../features/brand/brandSlice";
import reviewTableSlice from "../pages/ScenarioCreation/components/ReviewTable/reviewTableSlice";
import loaderSlice from "../features/ui/loaderSlice";
import outputfilterSlice from "../features/outputFilters/outputfilterSlice";
import scenarioCreationSlice from "../features/scenarioCreation/scenarioCreationSlice";
import popupSlice from "../features/ui/popupSlice";
import outputOverviewSlice from "../features/outputOverview/outputOverviewSlice";
import mapSlice from "../features/map/mapSlice";
import performanceTableSlice from "../features/performanceTable/performanceTableSlice";
import outputSegmentDeepDiveSlice from "../features/outputSegmentDeepDive/outputSegmentDeepDiveSlice";
import outputBrandsSlice from "../features/outputSegmentDeepDive/outputBrandsSlice";

export const store = configureStore({
  reducer: {
    auth: authSlice,
    loader: loaderSlice,
    popup: popupSlice,
    filters: filterSlice,
    scenarioLibrary: scenarioLibrarySlice,
    audio: audioSlice,
    performanceTable: performanceTableSlice,
    segment: packSegmentsSlice,
    form: formSlice,
    metrics: metricsSlice,
    inputKpi: inputKpiSlice,
    brand: brandSlice,
    reviewTable: reviewTableSlice,
    outputFilters: outputfilterSlice,
    scenarioCreation: scenarioCreationSlice,
    outputOverview: outputOverviewSlice,
    map: mapSlice,
    outputSegmentDeepDive: outputSegmentDeepDiveSlice,
    outputBrands: outputBrandsSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
